import { createCoinElement } from "./single-coin.component";

export class AvailableCoinsComponent {
    
    private coinsContainer: HTMLButtonElement;
    private coinSearchInputEl: HTMLInputElement;
    private searchFilter = '';

    constructor(
        private rootElement: HTMLElement,
        private selectedCoins: Set<any>,
        private allCoins: any[],
        private addCoinCb: (coinId: string) => void) {
        this.coinsContainer = rootElement.querySelector('.available-coins-list')!;
        this.coinSearchInputEl = rootElement.querySelector('.coin-search')!;
        this.init();
        this.update();
    }

    init() {
        this.coinSearchInputEl.addEventListener('input', (e) => {
            this.searchFilter = (e.target as HTMLInputElement).value.trim().toLowerCase();
            this.update();
        });
    }

    update() {
        let selectableCoins = this.allCoins
            .filter(coin => !this.selectedCoins.has(coin.id));
        if (this.searchFilter) {
            selectableCoins = selectableCoins.filter(coin => coin.name.toLowerCase().includes(this.searchFilter));
        }
        this.coinsContainer.innerHTML = '';
        selectableCoins.forEach(coin => {
            const coinElement = createCoinElement(coin, "available", true, () => {
                this.searchFilter = '';
                this.coinSearchInputEl.value = '';
                this.addCoinCb(coin.id);
            });
            this.coinsContainer.appendChild(coinElement);
        });
    }

}
